import script from "./ObjectiveMoveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectiveMoveModal.vue?vue&type=script&setup=true&lang=js"

import "./ObjectiveMoveModal.vue?vue&type=style&index=0&id=0abd9b46&lang=scss&scoped=true"
import "./ObjectiveMoveModal.vue?vue&type=style&index=1&id=0abd9b46&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abd9b46"]])

export default __exports__